import { FormFastLane } from './form-fastlane';
import { FastLaneRequest } from './fastlane.model';

export enum FastLaneWizardStep {
	MAINDATA = 0, ITEMSDETAILS = 1, TRANSPORTDETAILS = 2, SUMMARY = 3
}
class WizardStateFastLane {
	static COMPUTE_INDEX_STEP(prototypeRequest: FastLaneRequest | FormFastLane) {
		const form = prototypeRequest instanceof FormFastLane
			? prototypeRequest : new FormFastLane().setFastLane(prototypeRequest);
		if (!form.isFastLaneHeaderValid()) {
			return FastLaneWizardStep.MAINDATA;
		}
		return FastLaneWizardStep.SUMMARY;
	}

	readonly form = new FormFastLane();
	lastSavedPrototypeRequest: FastLaneRequest;

	constructor(prototypeRequest: FastLaneRequest, lastSavedPrototypeRequest: FastLaneRequest) {
		this.form = new FormFastLane();
		this.form.setFastLane(prototypeRequest);
		this.lastSavedPrototypeRequest = lastSavedPrototypeRequest;
	}

	computeIndexStep() {
		return WizardStateFastLane.COMPUTE_INDEX_STEP(this.form);
	}
}
export class FastLaneWizardState {
	stepIndex: FastLaneWizardStep = FastLaneWizardStep.MAINDATA;
	isValid = false;
	exiting = false;
	errorInPage = false;
	readonly scrollPositionByStep = [0, 0, 0, 0, 0];
	readonly prototypeRequest: WizardStateFastLane;
	constructor(prototypeRequest: FastLaneRequest, lastSavedPrototypeRequest: FastLaneRequest) {
		this.prototypeRequest = new WizardStateFastLane(prototypeRequest, lastSavedPrototypeRequest);
	}
}
